module.exports = __webpack_public_path__ + "video/SAF-500-2_Ares_Ransomware_2025.a1dc5181.vtt";